import { useState } from 'react';
import { ItemSetName, KINGMAKER_SETS, SWAMPLAND_SETS, WOODLAND_SETS } from '../item/item-types';
import { PageSubTitle } from '../menu/page-sub-title';
import ItemSetTab from './item-set-tab';
import Border, { BorderType } from '../menu/border';

const TAB_LABELS = [
    { key: 'woodland', label: 'Woodland' },
    { key: 'swampland', label: 'Swampland' },
    { key: 'kingmaker', label: 'Kingmaker' },
];

const ItemSetIndex: React.FC = () => {
    const [activeTab, setActiveTab] = useState('woodland');

    let sets: ItemSetName[] = [];
    if (activeTab === 'woodland') sets = WOODLAND_SETS;
    else if (activeTab === 'swampland') sets = SWAMPLAND_SETS;
    else if (activeTab === 'kingmaker') sets = KINGMAKER_SETS;

    return (
        <div className='item-set-index'>
            <PageSubTitle
                label='Item Sets'
                name='item-set-index'
                image='/resources/compendium/item_sets_icon.png'
            />
            <div className='item-set-tabs'>
                {TAB_LABELS.map(tab => (
                    <span
                        className={`item-set-filter${activeTab === tab.key ? " active" : ""}`}
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        <Border type={BorderType.Tag} active={activeTab === tab.key}>
                            <span className='item-set-filter-text'>
                                {tab.label}
                            </span>
                        </Border>
                    </span>
                ))}
            </div>
            <div className='item-set-index-content'>
                <ItemSetTab sets={sets} />
            </div>
        </div>
    );
};

export default ItemSetIndex;